import { endsWith, round } from 'lodash';
import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import {
    getComparisonPerYear,
    getBarComparisonOptions
} from '../utilities/dataTransformer';


class BarChartRAAeachLand extends Component {
    constructor(props) {
        super(props);

        var comparisonPerYear = getComparisonPerYear();
        var burgenlandComparison = Math.round((((comparisonPerYear[2020][0][0].y)/(comparisonPerYear[2010][0][0].y))-1)*100)
        var kaerntenComparison = Math.round((((comparisonPerYear[2020][0][1].y)/(comparisonPerYear[2010][0][1].y))-1)*100)


        this.state = {

            options: getBarComparisonOptions(burgenlandComparison, kaerntenComparison),

            series: [{
                name: '2010',
                data: comparisonPerYear[2010][0]
            },
            {
                name: '2018',
                data: comparisonPerYear[2018][0]
            },
            {
                name: '2019',
                data: comparisonPerYear[2019][0]
            },
            {
                name: '2020',
                data: comparisonPerYear[2020][0]
            },

            ]
        };
    }


    componentDidUpdate(prevState) {
        if (this.state.shouldUpdate) {
            this.setState({
                ...this.state,
                shouldUpdate: false,
            });
            var comparisonPerYear = getComparisonPerYear();
            var burgenlandComparison = Math.round((((comparisonPerYear[2020][0][0].y)/(comparisonPerYear[2010][0][0].y))-1)*100)
            var kaerntenComparison = Math.round((((comparisonPerYear[2020][0][1].y)/(comparisonPerYear[2010][0][1].y))-1)*100)
    

            this.setState({
                options: getBarComparisonOptions(burgenlandComparison, kaerntenComparison),

                series: [{
                    name: '2010',
                    data: comparisonPerYear[2010]
                },
                {
                    name: '2018',
                    data: comparisonPerYear[2018]
                },
                {
                    name: '2019',
                    data: comparisonPerYear[2019]
                },
                {
                    name: '2020',
                    data: comparisonPerYear[2020]
                },

                ]
            })
        }
    }
    render() {
        return (
            <div className="chart-container">
            <Chart
                options={this.state.options}
                series={this.state.series}
                type='bar'
                height="100%"
                width="100%"
            /></div>
        );
    }
}

export default BarChartRAAeachLand;